var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSellout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#0DA9D5",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6255 11.6071L19.7866 12.3571L18.3084 11.0357V14.2857H17.1099V11.0357L15.6318 12.3571L14.7928 11.6071L17.7092 9L20.6255 11.6071ZM12.5356 24.6212C12.8152 24.8737 13.1534 25 13.5501 25C13.9467 25 14.2863 24.875 14.5688 24.625C14.8513 24.375 14.9925 24.0727 14.9925 23.7181C14.9925 23.3635 14.8527 23.0599 14.573 22.8074C14.2934 22.5548 13.9552 22.4286 13.5585 22.4286C13.1619 22.4286 12.8223 22.5536 12.5398 22.8036C12.2573 23.0536 12.1161 23.3559 12.1161 23.7105C12.1161 24.0651 12.2559 24.3687 12.5356 24.6212ZM20.6055 24.6212C20.8851 24.8737 21.2233 25 21.62 25C22.0167 25 22.3562 24.875 22.6387 24.625C22.9212 24.375 23.0624 24.0727 23.0624 23.7181C23.0624 23.3635 22.9226 23.0599 22.6429 22.8074C22.3633 22.5548 22.0251 22.4286 21.6285 22.4286C21.2318 22.4286 20.8922 22.5536 20.6097 22.8036C20.3273 23.0536 20.186 23.3559 20.186 23.7105C20.186 24.0651 20.3258 24.3687 20.6055 24.6212ZM9 10.7143V11.7857H10.5581L13.5144 17.5714L12.236 19.6786C12.0096 20.0476 12.0273 20.4107 12.2892 20.7679C12.5512 21.125 12.9329 21.3036 13.4345 21.3036H23.0624V20.2321H13.2547L14.3733 18.375H20.4257C20.7038 18.375 20.9597 18.3066 21.1936 18.1697C21.4274 18.0327 21.6176 17.8512 21.764 17.625L25 12.2143H23.6617L20.4598 17.2143H14.7129L11.3171 10.7143H9Z",
    fill: "#0DA9D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSellout);
export default __webpack_public_path__ + "static/media/icon-sellout.770e4ae5.svg";
export { ForwardRef as ReactComponent };